// eslint-disable-next-line import/no-duplicates
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import ProductCard from '@nykaa/product-card';
import ImpressionsHandler from '@nykaa/deals-utils/impressions';
import { IMPRESSION_TYPE } from '@nykaa/deals-utils/impressions/constants';
import ClickHandler from '@nykaa/deals-utils/clicks';
import { webActionTypes } from '@nykaa/deals-utils/clicks/constants';
import { handleRightClickCallback } from '../../helper';
import styled from '../../theme';
import IoElement from '../IOElement';
import { PRODUCT_EVENT } from '../../constants';
const CardWrapper = styled.div `
  position: relative;
  display: inline-block;
  background: #fff;
  width: ${({ isDesktop }) => (isDesktop ? '218px' : 'auto')};
  min-width: ${({ isDesktop }) => (isDesktop ? '218px' : '172px')};
  max-height: ${({ isDesktop }) => (isDesktop ? '324px' : '324px')};
  vertical-align: top;
  cursor: pointer;
  border: 1px solid #e1e1e1;
  border-left: none;
  a {
    text-decoration: none;
  }
  .width-limiter {
    max-width: 100%;
    height: 100%;
  }
`;
const TextLabel = styled.div `
  width: 100%;
  height: 32px;
  font-size: 14px;
  font-weight: 600;
  line-height: 2;
  letter-spacing: 0.57px;
  text-align: center;
  position: absolute;
  bottom: 0px;
  cursor: pointer;
  margin-bottom: 2px;
  color: ${(props) => props.theme.brandPrimary};
`;
const ProductWidget = (widgetData) => {
    const { params, trackingData: oldTrackingData, isServer, isDesktop, positionInParent, isDevModeEnabled, devModeData, } = widgetData;
    const { id, slug, imageUrl, trackingParams, parentWidgetId, appLinkData, appLinkType, price, mrp, quantity, title, sku, dynamicTags, brandName, } = params;
    let formattedSlug = slug || '';
    if (formattedSlug && formattedSlug[0] !== '/') {
        formattedSlug = `/${formattedSlug}`;
    }
    const dnImpressionData = {
        position1: oldTrackingData.position1,
        dn_page_type: oldTrackingData.namespace0,
        dn_page_section: oldTrackingData.namespace1,
        dn_tile_id: oldTrackingData.namespace2,
        dn_inventory_position: oldTrackingData.position1,
        dn_tile_position: oldTrackingData.position2,
        dn_transaction_id: oldTrackingData.transaction_id || `wid_${parentWidgetId}`,
        dn_tracking_metadata: params.trackingData.dn_tracking_metadata,
        dn_request_page_data: oldTrackingData.pageData1,
        dn_inventory_page_data: oldTrackingData.pageData2,
        dn_wtype: oldTrackingData.wtype,
        dn_wtype_version: oldTrackingData.wtype_version,
    };
    const productTrackingData = {
        product_sku: sku,
        product_price: price,
        product_mrp: mrp,
        product_dp: price,
        product_inventory: quantity,
        product_name: title,
        product_tags: dynamicTags || [],
        product_id: id,
        product_position: positionInParent - 1,
        product_brand: brandName,
        page_url: typeof window !== 'undefined' ? window.location.href : '',
    };
    const preparedProductTrackingData = Object.assign(Object.assign({}, productTrackingData), dnImpressionData);
    const clickedTrackingData = Object.assign(Object.assign({}, preparedProductTrackingData), { event_name: PRODUCT_EVENT.CLICK, event_type: 'click' });
    const handleIntersect = () => {
        ImpressionsHandler.syncCallback([Object.assign(Object.assign({}, preparedProductTrackingData), { hit_recorded_at: new Date().getTime() / 1000, event: 'product:impressions', event_name: PRODUCT_EVENT.IMPRESSIONS, id })], IMPRESSION_TYPE.PRODUCT);
    };
    const clickHandler = (event) => {
        event.preventDefault();
        ImpressionsHandler.handleClick(clickedTrackingData)
            .finally(() => {
            /**
             * ? Why finally?
             * even in case of an error in handling impression...
             * we would want the click to function as expected
             */
            ClickHandler.handleClick({
                appLinkData,
                appLinkType,
                trackingParams,
                webActionType: webActionTypes.URL_REDIRECTION,
                webActionUrl: formattedSlug,
                isDesktop,
            });
        });
    };
    const devModeHandler = (!!isDevModeEnabled && {
        onContextMenu: () => handleRightClickCallback(devModeData),
    });
    if (!id) {
        return null;
    }
    return (React.createElement(CardWrapper, { key: id + positionInParent, isDesktop: isDesktop },
        React.createElement(IoElement, { isServer: isServer, onIntersect: handleIntersect, className: "width-limiter", childClassName: "width-limiter", isV2Present: false },
            React.createElement(ProductCard, { product: params, showProFlag: false, imageUrl: imageUrl, pdpPageUrl: formattedSlug, lazyLoadImage: positionInParent > 3, handelTagClick: () => {
                    ImpressionsHandler.handleClick(clickedTrackingData);
                }, size: isDesktop ? 'small' : 'small' }),
            React.createElement(TextLabel, Object.assign({ onClick: clickHandler }, devModeHandler), "View"))));
};
export default ProductWidget;
